import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=4c3b8bf4&scoped=true&"
import script from "./mapping.vue?vue&type=script&lang=js&"
export * from "./mapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b8bf4",
  null
  
)

export default component.exports